// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"ee26ce84","187":"66b499cf","410":"929580f3"}[chunkId] + ".chunk.css";
};